const Radio = ({ name, value, label, checked, disabled, click }) => {
  return (
    <div>
      <label style={{ display: "flex", alignItems: "center" }}>
        <input
          type="radio"
          name={name}
          value={value}
          defaultChecked={checked}
          disabled={disabled}
          onClick={(e) => click(name, e.target.value)}
        />
        <span className={disabled ? "disabled" : ""}>{label}</span>
      </label>
    </div>
  );
};

export default Radio;
